import { FAB_SURGE_CREATE_USER, FAB_SURGE_CREATE_USER_SUCCESS, FAB_SURGE_CREATE_USER_ERROR, FAB_SURGE_CREATE_USER_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateFabUser = (state = initialState, action) => {
  switch (action.type) {
    case FAB_SURGE_CREATE_USER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_CREATE_USER_SUCCESS:
      console.log('hello action', action.payload);
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_CREATE_USER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case FAB_SURGE_CREATE_USER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateFabUser;
